import { Pipe, PipeTransform } from '@angular/core';
import { Dashboard } from '../../modelos/dashboard';

@Pipe({
  name: 'filtroDashboards',
  pure: false
})
export class FiltroDashboardsPipe implements PipeTransform {

  transform(dashboards: Dashboard[], filtro?: string): any {
    if (dashboards === undefined || filtro === undefined || filtro.trim() === '') {
      return dashboards;
    }
    filtro = filtro.toLocaleLowerCase();
    return dashboards.filter(dashboard => dashboard.nomeDashboard.toLocaleLowerCase().indexOf(filtro) >= 0);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/filtros/pipes/filtro-dashboards.pipe.ts